import { LegalPage, LegalSection } from "./LegalShared";

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      section="§ Codex · Privacy Policy"
      title="What the Lyceum remembers."
      subtitle="Plain-language disclosure of what we collect, why, and how to remove it."
    >
      <LegalSection n="I" title="What We Store">
        <ul style={{ paddingLeft: 20, display: "flex", flexDirection: "column", gap: 6 }}>
          <li>Your email (and Google profile name + picture if you use Google sign-in).</li>
          <li>bcrypt-hashed password — we can never read your cleartext password.</li>
          <li>The sprints you create: discovery messages, audits, generated code, chaos results, deploy metadata.</li>
          <li>Bring-your-own tokens for DeepSeek, GitHub, Vercel, and Railway — stored encrypted-at-rest.</li>
          <li>Seal analytics: anonymised view/share counts and 14-day view timestamps for sprints you mark public.</li>
        </ul>
      </LegalSection>

      <LegalSection n="II" title="What We Do Not Store">
        We do not store: your cleartext password, the bodies of LLM prompts sent through your
        own BYOK key beyond what is required to render your sprint, browser fingerprints, or
        third-party advertising identifiers. We do not sell data.
      </LegalSection>

      <LegalSection n="III" title="Cookies &amp; Sessions">
        A single httpOnly cookie (<code style={{ color: "var(--brass)" }}>session_token</code>)
        is set when you log in. It expires in 7 days and is used solely to recognise you across
        requests. No third-party tracking cookies are set by HEXIS OS.
      </LegalSection>

      <LegalSection n="IV" title="Third-Party Requests">
        When you send a message to Claude or DeepSeek, run a deploy to Vercel/Railway, or push
        to GitHub, the relevant payload is forwarded to that provider's API using your own
        tokens (or the Emergent Universal Key for Claude). We do not retain request bodies
        on our servers beyond the short window needed to stream the response back to you.
      </LegalSection>

      <LegalSection n="V" title="Public Sprints">
        If you toggle a Seal to <strong>Public</strong>, the sprint's name, description, 6-pillar
        completion state, chaos summary, Aristotelian rank, owner display name, and deploy
        status become accessible via <code style={{ color: "var(--brass)" }}>/seal/:id</code> —
        including via the Leaderboard. Your code files are ZIP-downloadable only when both
        chaos passes and visibility is public. Flip back to Private at any time.
      </LegalSection>

      <LegalSection n="VI" title="Deletion &amp; Export">
        Delete a sprint from your Laboratory at any time — the project and its seal analytics
        are removed immediately from our database. Full account deletion: email
        <a href="mailto:delete@hexis.os" className="link-brass" style={{ marginLeft: 4 }}>delete@hexis.os</a>
        and we'll purge your user record and all owned projects within 7 days.
      </LegalSection>

      <LegalSection n="VII" title="Contact">
        Questions, corrections, or privacy requests:
        <a href="mailto:privacy@hexis.os" className="link-brass" style={{ marginLeft: 4 }}>privacy@hexis.os</a>.
      </LegalSection>

      <p style={{ fontStyle: "italic", fontSize: 14, color: "var(--muted)", textAlign: "center", marginTop: 14 }}>
        "Knowing yourself is the beginning of all wisdom." — Ἀριστοτέλης
      </p>
    </LegalPage>
  );
}
